AGADash.Filter.Table = (function () {

    var changeHandler = function (e) {
        var handles = $(e.currentTarget).val();
        var me = $(e.target).closest(".dash-filter");

        AGADash.Panel.cancelSchedule();

        var key = "";
        if (handles && handles.length > 0)
            key = "user|" + $(me).attr("filter-id") + "|" + handles + "|";

        $(me).attr("filter-user-key", key);

        AGADash.Panel.scheduleUpdate(e.target);
    };

    var initTableFilter = function (target, filterInfo) {
        var url = AGADash.serviceUrl() + "/PanelFilterItems";

        var ajaxConfig = {
            url: url,
            dataType: "json",
            delay: 250,
            data: function (params) {
                if (params.term === undefined)
                    params.term = "";
                params.page = params.page || 1;
                var query = {};
                query["filter"] = $(this).closest(".dash-filter").attr("filter-id");
                query["selecteds"] = "nao";
                query["firstIndex"] = (params.page - 1) * 30;
                query["criteria"] = params.term;
                return query;
            },
            processResults: function (data) {
                return {
                    results: $.map(data.Items, function (item) {
                        return { id: item.id, text: item.desc };
                    }),
                    pagination: {
                        more: data.More === "S"
                    }
                };
            },
            cache: true
        };

        var config = {
            multiple: true,
            closeOnSelect: true,
            ajax: ajaxConfig,
            language: "pt-BR",
            escapeMarkup: function (markup) {
                return markup;
            },
            formatResult: function (data) {
                return data.desc;
            },
            formatSelection: function (data) {
                return data.desc;
            }
        };

        if (filterInfo.MaxLength && filterInfo.MaxLength > 0) {
            if (filterInfo.MaxLength === 1) {
                config.multiple = false;
            } else {
                config["maximumInputLength"] = filterInfo.MaxLength; 
                config["maximumSelectionLength"] = filterInfo.MaxLength;
            }
        }
        
        var selObj = $(target).select2(config);
        selObj.on("change", changeHandler);
    };

    var renderFilter = function (parent, filterInfo) {
        var input = document.createElement("select");
        $(input).addClass("form-control input-sm dash-filter-table")
            .attr({
                "type": "text",
                "value": ""
            })
            .appendTo(parent);

        initTableFilter(input, filterInfo);
    };

    return {
        renderFilter: renderFilter
    };


})();

AGADash.Filter.setFilterClass("tabela", AGADash.Filter.Table);